var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-layout',{attrs:{"add-container":false}},[_c('page-header',{attrs:{"title":"Perfil do usuário"}}),_c('div',{staticClass:"pageBody"},[_c('div',{staticClass:"userPreferences"},[_c('email-reports'),_c('change-password')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }